import { render } from "./X1172.vue?vue&type=template&id=0ca2fd2a"
import script from "./X1172.vue?vue&type=script&lang=js"
export * from "./X1172.vue?vue&type=script&lang=js"

import "./X1172.vue?vue&type=style&index=0&id=0ca2fd2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__